export function subclientValidate(subclient){
    var result = true;

    result = validateId(subclient.id);
    result = validateName(subclient.attributes.name);
    result = validateClientId(subclient.attributes.client_id);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof name === 'string' && name.trim() !== '') return true;
    else return false;
}

function validateClientId(client_id){    
    if(Number.isInteger(client_id)) return true;
    else return false;
}